import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';

export const buildPermissionKey = (
  resourceCode: string,
  actionCode?: string,
) => (actionCode ? `${resourceCode}:${actionCode}` : resourceCode);

export const hasResourceAccess = (
  access: AuthorizedResourceAccessMap | undefined,
  resourceCode: string | undefined,
) => Boolean(resourceCode && access?.[buildPermissionKey(resourceCode)]);

export const hasActionAccess = (
  access: AuthorizedResourceAccessMap | undefined,
  resourceCode: string | undefined,
  actionCode: string | undefined,
) =>
  Boolean(
    resourceCode &&
      actionCode &&
      hasResourceAccess(access, resourceCode) &&
      access?.[buildPermissionKey(resourceCode, actionCode)],
  );
